import React from "react";
import { useTranslation } from "react-i18next";

export function PageNotFound() {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t("pageNotFound.title")}</h1>
    </div>
  );
}
